import { render } from "./Tag.vue?vue&type=template&id=ce78165a"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/content/Tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce78165a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce78165a', __exports__)) {
    api.reload('ce78165a', __exports__)
  }
  
  module.hot.accept("./Tag.vue?vue&type=template&id=ce78165a", () => {
    api.rerender('ce78165a', render)
  })

}


export default __exports__